/**
 * 越南语（vi）
 */

import viLocale from 'element-ui/lib/locale/lang/vi'

export default {
  ...viLocale,
  common: {},
  // 语言
  lang: {
    english: 'AnhName',
    spanish: 'Tây Ban',
    japanese: 'Nhật',
    portuguese: 'PortugueName',
    french: 'Pháp',
    russian: 'Nga',
    arabic: 'Description',
    german: 'Đức',
    italian: 'ÝName',
    vietnam: 'Việt',
    turkey: 'Thổ',
    korean: 'Hàn',
    thai: 'Thái',
    dutch: 'Hà',
    hebrew: 'Hebrew',
    indonesian: 'Indonesia'
  },

  // 苏子龙
  // 现货页面 inSrock
  inSrock: {}

  // 张丰

  // 孙泽严
}
